import React from 'react';
import PropTypes from 'prop-types';
import './DraftStatusHeader.css';

const DraftStatusHeader = ({ draftState, userId }) => {
  const { currentPicker, round, pickInRound, timeLeft, isDraftComplete } = draftState;
  const isMyTurn = currentPicker?.userId === userId;

  if (isDraftComplete) {
    return (
      <div className="draft-status-header complete">
        <span className="status-value">DRAFT COMPLETE</span>
      </div>
    );
  }

  return (
    <div className="draft-status-header">
      <div className="status-module">
        <span className="status-label">UP NOW</span>
        <span className="status-value">{isMyTurn ? 'Your Pick' : (currentPicker?.username || 'N/A')}</span>
      </div>
      <div className="status-module">
        <span className="status-label">PICK</span>
        <span className="status-value">{`Round ${round}, Pick ${pickInRound}`}</span>
      </div>
      <div className="status-module timer">
        <span className="status-label">TIME LEFT</span>
        <span className="status-value">
          {draftState.timeLeft ? (
            <>
              {draftState.timeLeft}
              <span className="timer-unit">s</span>
            </>
          ) : (
            <span className="timer-unit">&infin;</span>
          )}
        </span>
      </div>
    </div>
  );
};

DraftStatusHeader.propTypes = {
  draftState: PropTypes.shape({
    currentPicker: PropTypes.shape({
      username: PropTypes.string,
      userId: PropTypes.string,
    }),
    round: PropTypes.number,
    pickInRound: PropTypes.number,
    timeLeft: PropTypes.number,
    isDraftComplete: PropTypes.bool,
  }).isRequired,
  userId: PropTypes.string.isRequired,
};

export default DraftStatusHeader; 